/**
 * Colonne de marque de la page `/login`, affichée UNIQUEMENT à partir de `lg`,
 * sur la moitié gauche à fond BLANC.
 *
 * Couleurs LITTÉRALES foncées : l'app est en thème océan (les tokens `ink-*`
 * sont clairs, prévus pour un fond sombre) → sur ce fond blanc on force des
 * navy/bleus explicites, sinon le texte serait blanc-sur-blanc.
 *
 * Sur mobile la page reste une colonne unique (logo compact + carte de
 * connexion) : ce bloc est `hidden` sous `lg`, il n'ajoute donc rien à l'écran
 * étroit — c'est la garantie que le rendu mobile n'a pas bougé.
 *
 * La copie reprend celle de l'accueil `/decouverte` et du Hero du site.
 * La garder alignée avec `features/decouverte/decouverte-slides.ts`.
 */

import { CompassLogo } from '@jeraisonne/ui';

const TAGLINE = 'Apprendre à raisonner.';
const SUBLINE = 'Pas à recopier.';

const POINTS: readonly string[] = [
  'Chaque ligne de ton brouillon est vérifiée tout de suite.',
  'Chaque méthode devient une SKILLCARD à faire monter.',
  'Un diagnostic gratuit, puis ton programme de l’année.',
  'Chaque dimanche, un défi Live School en direct.',
];

export function LoginBranding() {
  return (
    <div className="hidden max-w-md lg:flex lg:flex-col lg:items-start lg:gap-8">
      <CompassLogo size="xl" wordmarkClassName="text-[#0a4191]" />

      <h1 className="font-display text-4xl font-extrabold leading-tight text-[#0f2f63]">
        {TAGLINE}
        <br />
        <span className="text-[#2f7de0]">{SUBLINE}</span>
      </h1>

      <ul className="space-y-4">
        {POINTS.map((point) => (
          <li key={point} className="flex items-start gap-3 text-[15px] text-[#42557a]">
            <svg
              viewBox="0 0 20 20"
              className="mt-0.5 h-5 w-5 shrink-0 text-[#2f7de0]"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.7-9.3a1 1 0 00-1.4-1.4L9 10.6 7.7 9.3a1 1 0 00-1.4 1.4l2 2a1 1 0 001.4 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            {point}
          </li>
        ))}
      </ul>
    </div>
  );
}
